const ALLOWED_COMMUNITIES = [
  'fetisch',
  'fetish',
  'popcorn',
  'poppen',
  'popcorn.dating',
  'gayscom',
  'gayde',
];

// Google Analytics ID
const GA_MEASUREMENT_ID = 'G-34YBBWP9CH';

export function loadScript(src: string, id?: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (id && document.getElementById(id)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    if (id) {
      script.id = id;
    }

    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));

    document.head.appendChild(script);
  });
}



function getCommunityFromUrl(): string | null {
  const path = window.location.pathname;
  const match = path.match(/\/chatbot\/[^/]+\/([^/]+)/);
  return match ? match[1] : null;
}

// check if Google Analytics should be loaded for the current community
function shouldLoadGoogleAnalytics(community: string): boolean {
  return ALLOWED_COMMUNITIES.includes(community.toLowerCase());
}

// load Google Analytics script and initialize it
export async function loadGoogleAnalytics(): Promise<void> {
  console.log('Attempting to load Google Analytics...');
  try {
    const community = getCommunityFromUrl();

    if (!community) {
      console.log('No community found in URL, skipping Google Analytics');
      return;
    }

    if (!shouldLoadGoogleAnalytics(community)) {
      console.log(`Google Analytics not enabled for community: ${community}`);
      return;
    }

    console.log(`Loading Google Analytics for community: ${community}`);

    await loadScript(
      `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`,
      'gtag-script',
    );

    (window as any).dataLayer = (window as any).dataLayer || [];
    const gtag = (...args: any[]) => {
      (window as any).dataLayer.push(args);
    };
    (window as any).gtag = gtag;

    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);

    console.log(
      `Google Analytics loaded successfully for community: ${community}`,
    );
  } catch (error) {
    console.error('Failed to load Google Analytics:', error);
  }
}